/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroupTypeEnum,
    DisciplineGroupTypeEnumFromJSON,
    DisciplineGroupTypeEnumFromJSONTyped,
    DisciplineGroupTypeEnumToJSON,
} from './DisciplineGroupTypeEnum';
import {
    DisciplineSubgroupDTO,
    DisciplineSubgroupDTOFromJSON,
    DisciplineSubgroupDTOFromJSONTyped,
    DisciplineSubgroupDTOToJSON,
} from './DisciplineSubgroupDTO';
import {
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumFromJSONTyped,
    SemesterTypeEnumToJSON,
} from './SemesterTypeEnum';
import {
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumFromJSONTyped,
    StudyYearEnumToJSON,
} from './StudyYearEnum';
import {
    SubjectsForGroupDTO,
    SubjectsForGroupDTOFromJSON,
    SubjectsForGroupDTOFromJSONTyped,
    SubjectsForGroupDTOToJSON,
} from './SubjectsForGroupDTO';

/**
 * 
 * @export
 * @interface DisciplineGroupDTO
 */
export interface DisciplineGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroupDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {DisciplineGroupTypeEnum}
     * @memberof DisciplineGroupDTO
     */
    type?: DisciplineGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DisciplineGroupDTO
     */
    disiplineCount?: number;
    /**
     * 
     * @type {SemesterTypeEnum}
     * @memberof DisciplineGroupDTO
     */
    semester?: SemesterTypeEnum;
    /**
     * 
     * @type {StudyYearEnum}
     * @memberof DisciplineGroupDTO
     */
    studyYear?: StudyYearEnum;
    /**
     * 
     * @type {string}
     * @memberof DisciplineGroupDTO
     */
    studyPlanId?: string;
    /**
     * 
     * @type {Array<DisciplineSubgroupDTO>}
     * @memberof DisciplineGroupDTO
     */
    subgroups?: Array<DisciplineSubgroupDTO> | null;
    /**
     * 
     * @type {Array<SubjectsForGroupDTO>}
     * @memberof DisciplineGroupDTO
     */
    subjects?: Array<SubjectsForGroupDTO> | null;
}

export function DisciplineGroupDTOFromJSON(json: any): DisciplineGroupDTO {
    return DisciplineGroupDTOFromJSONTyped(json, false);
}

export function DisciplineGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : DisciplineGroupTypeEnumFromJSON(json['type']),
        'disiplineCount': !exists(json, 'disiplineCount') ? undefined : json['disiplineCount'],
        'semester': !exists(json, 'semester') ? undefined : SemesterTypeEnumFromJSON(json['semester']),
        'studyYear': !exists(json, 'studyYear') ? undefined : StudyYearEnumFromJSON(json['studyYear']),
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'subgroups': !exists(json, 'subgroups') ? undefined : (json['subgroups'] === null ? null : (json['subgroups'] as Array<any>).map(DisciplineSubgroupDTOFromJSON)),
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectsForGroupDTOFromJSON)),
    };
}

export function DisciplineGroupDTOToJSON(value?: DisciplineGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': DisciplineGroupTypeEnumToJSON(value.type),
        'disiplineCount': value.disiplineCount,
        'semester': SemesterTypeEnumToJSON(value.semester),
        'studyYear': StudyYearEnumToJSON(value.studyYear),
        'studyPlanId': value.studyPlanId,
        'subgroups': value.subgroups === undefined ? undefined : (value.subgroups === null ? null : (value.subgroups as Array<any>).map(DisciplineSubgroupDTOToJSON)),
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectsForGroupDTOToJSON)),
    };
}

